export const initialDirection: 'ltr' | 'rtl' | undefined = 'ltr';
